import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { Input, Button, Typography, Alert, Space } from "antd";
import {
  AI_API_GENERATE_URL
} from "../../utils/contrains";

const { Title } = Typography;

class CreateExamQuestion extends Component {
  state = {
    question: "",
    output: "",
    fullResponse: "",
    error: "",
    isGenerating: false,
    isOutputComplete: false,
    copyButtonColor: "#8C0044",
    course: "",
    numberofQuestions: "",
  };

  constructor(props) {
    super(props);

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.renderText = this.renderText.bind(this);
    this.copyToClipboard = this.copyToClipboard.bind(this);
  }

  handleInputChange(event) {
    const { id, value } = event.target;
    this.setState({ [id]: value });
  }

  parseResponseData = (data) => {
    try {
      const lines = data.split("\n");
      const jsonArray = lines
        .filter((line) => line.trim() !== "")
        .map((line) => JSON.parse(line));
      return jsonArray;
    } catch (error) {
      console.error("解析 response.data 時發生錯誤：", error);
      return [];
    }
  };

  handleSubmit(event) {
    event.preventDefault();
    const { course, numberofQuestions } = this.state;

    if (!course.trim() || !numberofQuestions.trim()) {
      this.setState({
        error: "請確保課程名稱和題數已填寫。",
      });
      return;
    }

    const api_url = AI_API_GENERATE_URL;
    const payload = {
      model: "gemma2",
      prompt:
        `你是一位${course}課程講師，要對學生實施隨堂考試，考試主題是有關${course}的問題，以繁體中文描述問題。\n` +
        `共出${numberofQuestions}道題。每道題目都有 (1) (2) (3) (4) 四個答案的選擇題:\n` +
        `解答請不要列在題目的下面，列在第${numberofQuestions}題的後面。`,
    };

    this.setState({
      isGenerating: true,
      output: "",
      error: "",
      isOutputComplete: false,
    });

    axios
      .post(api_url, payload)
      .then((response) => {
        if (response.status === 200) {
          const fullResponse = response.data;
          this.setState({ fullResponse }, () => {
            this.renderText(fullResponse);
          });
        } else {
          this.setState({
            error: `API 回應碼: ${response.status}`,
            isGenerating: false,
          });
        }
      })
      .catch((error) => {
        this.setState({
          error: `API 請求失敗：${error.message}`,
          isGenerating: false,
        });
      });
  }

  renderText(data) {
    const jsonArray = this.parseResponseData(data);

    if (jsonArray.length > 0) {
      const responses = jsonArray.map((item) => item.response).join("");

      let index = 0;
      this.setState({
        output: "",
        isGenerating: true,
        isOutputComplete: false,
      });

      this.interval = setInterval(() => {
        if (index < responses.length) {
          this.setState((prevState) => ({
            output: prevState.output + responses[index],
          }));
          index += 1;
        } else {
          clearInterval(this.interval);
          this.interval = null;
          this.setState({ isGenerating: false, isOutputComplete: true });
        }
      }, 100);
    } else {
      this.setState({ output: "沒有有效的回應", isGenerating: false });
    }
  }

  stopRendering() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
    this.setState({ isGenerating: false });
  }

  clearContent() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
    this.setState({
      output: "",
      isGenerating: false,
      isOutputComplete: false,
      copyButtonColor: "#8C0044",
    });
  }

  formatOutputText(text) {
    return text.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");
  }

  copyToClipboard() {
    const { output, question } = this.state;
    const textToCopy = `提問：${question}\n回答：${output}`;

    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        this.setState({ copyButtonColor: "#4CAF50" });
        setTimeout(() => {
          this.setState({ copyButtonColor: "#8C0044" });
        }, 2000);
      })
      .catch((err) => {
        console.error("複製失敗：", err);
      });
  }

  render() {
    return (
      <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
        <Title level={1}>模擬出題測驗</Title>

        <form onSubmit={this.handleSubmit}>
          <Space direction="vertical" style={{ width: "100%" }}>
            <Input
              id="course"
              value={this.state.course}
              onChange={this.handleInputChange}
              placeholder="課程名稱"
              style={{ height: "50px" }}
            />
            <Input
              id="numberofQuestions"
              value={this.state.numberofQuestions}
              onChange={this.handleInputChange}
              placeholder="題數"
              style={{ height: "50px" }}
              type="number"
            />
            <Space>
              <Button
                type="primary"
                htmlType="submit"
                loading={this.state.isGenerating}
              >
                {this.state.isGenerating ? "出題中" : "送出提問"}
              </Button>
              <Button
                onClick={() => this.stopRendering()}
                disabled={!this.state.isGenerating}
              >
                停止輸出
              </Button>
              <Button onClick={() => this.clearContent()}>清除內容</Button>
            </Space>
          </Space>
        </form>

        {this.state.error && (
          <Alert
            message="錯誤"
            description={this.state.error}
            type="error"
            showIcon
            style={{ marginTop: "20px" }}
          />
        )}

        <div
          style={{
            marginTop: "20px",
            whiteSpace: "pre-line",
            fontSize: "18px",
            lineHeight: "1.5",
            backgroundColor: this.state.isGenerating ? "#f0f0f0" : "#ffffff",
            padding: "10px",
            borderRadius: "5px",
          }}
          dangerouslySetInnerHTML={{
            __html:
              this.state.output &&
              ` ${this.formatOutputText(
                 this.state.output
               )}`,
          }}
        />

        {this.state.isOutputComplete && (
          <Button
            onClick={this.copyToClipboard}
            style={{
              marginTop: "10px",
              backgroundColor: this.state.copyButtonColor,
              color: "#FFFFFF",
            }}
          >
            複製內容
          </Button>
        )}
      </div>
    );
  }
}

export default connect((state) => ({ user: state.user }), {})(CreateExamQuestion);
